module.exports = __webpack_public_path__ + "static/reinserir-dc457f22f24f1acff768e06f217dde01.svg";